/**
 * 2048 经典版游戏应用入口
 * 挂载到服务端渲染页面的 #game-2048-app 元素
 */
import { createApp } from 'vue'
import App from './App.vue'

const mountEl = document.getElementById('game-2048-app')

if (mountEl) {
    const app = createApp(App)

    if (import.meta.env.DEV) {
        app.config.performance = true
    }

    app.config.errorHandler = (err, _instance, info) => {
        console.error('[game-2048] Vue Error:', err)
        console.error('[game-2048] Error Info:', info)
    }

    app.mount(mountEl)
}
